var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tween-num',_vm._b({attrs:{"duration":_vm.duration,"easing":"easeOutSine"}},'tween-num',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }